"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _styledComponents = require("styled-components");

var _ConfigProvider = require("../../providers/ConfigProvider");

var _colors = require("./colors");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var successStyles = {
  normal: (0, _styledComponents.css)(["&:hover:not(:active){background-color:", ";}"], _colors.success),
  ghost: (0, _styledComponents.css)(["&:hover:not(:active){color:", ";}"], _colors.success),
  // The inverted variant disallows "intents"
  inverted: (0, _styledComponents.css)([""])
};
var dangerStyles = {
  normal: (0, _styledComponents.css)(["&:hover:not(:active){background-color:", ";}"], _colors.danger),
  ghost: (0, _styledComponents.css)(["&:hover:not(:active){color:", ";}"], _colors.danger),
  // The inverted variant disallows "intents"
  inverted: (0, _styledComponents.css)([""])
};

var intent = _styledTheming.default.variants(_ConfigProvider.themeKeys.mode, 'intent', {
  success: {
    light: function light(_ref) {
      var _ref$variant = _ref.variant,
          variant = _ref$variant === void 0 ? 'normal' : _ref$variant;
      return successStyles[variant];
    },
    dark: function dark(_ref2) {
      var _ref2$variant = _ref2.variant,
          variant = _ref2$variant === void 0 ? 'normal' : _ref2$variant;
      return successStyles[variant];
    }
  },
  danger: {
    light: function light(_ref3) {
      var _ref3$variant = _ref3.variant,
          variant = _ref3$variant === void 0 ? 'normal' : _ref3$variant;
      return dangerStyles[variant];
    },
    dark: function dark(_ref4) {
      var _ref4$variant = _ref4.variant,
          variant = _ref4$variant === void 0 ? 'normal' : _ref4$variant;
      return dangerStyles[variant];
    }
  }
});

var _default = intent;
exports.default = _default;